import {useDispatch, useSelector} from "react-redux";
import {cloneDeep} from "lodash";
import InputComponent from "../../../components/input.component";
import React from "react";
import {setMiraculousRetinolSeriesBenefitDetail} from "../../../reducers/miraculous-retinol-series.reducer";

const ItemBenefit = ({fieldList, index}) => {
    const dispatch = useDispatch()
    const {benefitDetail, miraculousRetinolSeriesErrorMessage} = useSelector(state => state.miraculousRetinolSeriesReducer)

    const onChange = (key, value) => {
        const copyItemList = cloneDeep(benefitDetail.item_list)
        copyItemList[index][key] = value
        dispatch(setMiraculousRetinolSeriesBenefitDetail({item_list: copyItemList}))
    }

    return (
        <div className={"row space-x-16"}>
            <div className={"col space-y-4 w-1/2"}>
                <InputComponent item={fieldList[0]} data={benefitDetail?.item_list?.[index]?.[fieldList[0].key]} error={miraculousRetinolSeriesErrorMessage} onChange={onChange}/>
            </div>
            <div className={"col space-y-4 w-1/2"}>
                {fieldList[1].map((item, i) => (
                    <InputComponent key={i} item={item} data={benefitDetail?.item_list?.[index]?.[item.key]} error={miraculousRetinolSeriesErrorMessage} onChangeInput={onChange} onChange={onChange}/>
                ))}
            </div>
        </div>
    )
}

export default ItemBenefit